export default __webpack_public_path__ + "static/media/mainImage.b10ea1a7.jpg";